import React, { useState } from 'react'
import { Tooltip, IconButton, TableCell, TableRow, CircularProgress } from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import SummarizeIcon from '@mui/icons-material/Summarize'
import Delete from './Delete'
import { useSendPayoutEmailById } from '../../api/sales-commission'
import { useSnackbar } from 'notistack'
import EmailIcon from '@mui/icons-material/Email'
import ErrorIcon from '@mui/icons-material/Error'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { EMAIL_STATUS } from '../../constant/email-status'

const Row = ({ data, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)
  const { mutateAsync, isLoading } = useSendPayoutEmailById()
  const { enqueueSnackbar } = useSnackbar()

  const handleSendEmail = async () => {
    try {
      await mutateAsync({ id: data._id })
      enqueueSnackbar('Email sent successfully.', { variant: 'success' })
    } catch (e) {
      const message =
        e?.response?.data?.errors?.[0]?.msg || 'Something went wrong. Please try again.'
      enqueueSnackbar(message, { variant: 'error' })
    } finally {
      await refetch()
    }
  }

  const renderEmailDeliveryStatus = () => {
    if (isLoading || data.emailDeliveryStatus === EMAIL_STATUS.SENDING)
      return <CircularProgress size={20} color='inherit' />
    else if (data.emailDeliveryStatus === EMAIL_STATUS.ERROR)
      return <ErrorIcon fontSize='small' style={{ color: 'red' }} />
    else if (data.emailDeliveryStatus === EMAIL_STATUS.SUCCESS)
      return <CheckCircleIcon fontSize='small' style={{ color: 'green' }} />
    else return null
  }

  return (
    <>
      <TableRow style={{ borderBottom: 'unset' }}>
        <TableCell>{data.name}</TableCell>
        <TableCell>{data.email}</TableCell>
        <TableCell>
          <a href={data.url} target='_blank' rel='noopener noreferrer'>
            <Tooltip title='View'>
              <IconButton>
                <SummarizeIcon />
              </IconButton>
            </Tooltip>
          </a>
        </TableCell>
        <TableCell>
          <Tooltip title='Send Email'>
            <span>
              <IconButton
                onClick={handleSendEmail}
                disabled={isLoading || data.emailDeliveryStatus === EMAIL_STATUS.SENDING}
              >
                <EmailIcon fontSize='small' />
              </IconButton>
            </span>
          </Tooltip>
        </TableCell>
        <TableCell>{renderEmailDeliveryStatus()}</TableCell>
        <TableCell>
          <Tooltip title='Delete'>
            <IconButton onClick={() => setOpenDelete(true)}>
              <DeleteOutlinedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
    </>
  )
}

export default Row
